import {
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
} from "@mui/material";
import {
    MprcDialogTitleClose,
    MprcRequestErrorReport,
    MprcRequestIndicator,
} from "components";
import { ButtonSave } from "components/buttons";
import { MprcResolveRequestErrors } from "components/MprcRequestErrorReport";
import { MprcStringToHtml } from "components/MprcStringToHtml";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    onClose: (success: boolean) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const UserChangeEmailDialog: React.FC<IPros> = (props) => {
    const api = useCoreApi();
    const { t } = useTranslation();
    const { onClose } = props;

    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>();
    const [validationErrors, setValidationErrors] = useState<string[]>();

    const { enqueueSnackbar } = useSnackbar();
    const inputRef = useRef<HTMLInputElement>(undefined);

    ////////////////////////////////////////////////////////////////////////////
    ///
    const handleChangeEmail = async () => {
        setValidationErrors(undefined);
        try {
            setLoading(true);
            await api.v1.user.changeEmail({ email });
            enqueueSnackbar(t("User.ChangeEmail.SuccessMessage"), { variant: "success" });
            onClose(true);
        } catch (e) {
            var r = MprcResolveRequestErrors(e);
            setViewError(r.otherErrors);

            if (r.fieldsWithError != undefined) {
                setValidationErrors(
                    (r.fieldsWithError["email"] ?? [])
                );

                inputRef.current?.focus();
            }
        } finally {
            setLoading(false);
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT's
    ////////////////////////////////////////////////////////////////////////////

    // Ao iniciar pela primeira vez...
    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Dialog open fullWidth maxWidth="sm" onClose={() => onClose(false)}>
            <MprcDialogTitleClose
                title={t("User.ChangeEmail.Title")}
                onClose={() => onClose(false)}
            />
            <DialogContent>
                <MprcRequestErrorReport error={viewError} />
                <MprcRequestIndicator visible={loading} />
                <Grid container spacing={2} direction="column">
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            fullWidth
                            required
                            name="email"
                            label={t("User.ChangeEmail.EmailLabel")}
                            placeholder={t("User.ChangeEmail.EmailPlaceholder")}
                            inputRef={inputRef}
                            error={
                                validationErrors != undefined &&
                                validationErrors.length > 0
                            }

                            helperText={
                                validationErrors != undefined &&
                                    validationErrors.length > 0 ? (
                                    <MprcStringToHtml text={validationErrors} />
                                ) : null
                            }
                            margin="dense"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            slotProps={{
                                input: {
                                    inputProps: { maxLength: 2048 }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid size={{ xs: 12 }} alignSelf="center">
                    <ButtonSave
                        disabled={email.length === 0 || loading}
                        onClick={handleChangeEmail}
                    />
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
